export default __webpack_public_path__ + "static/media/logo.23415359.svg";